import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3154fc20"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "auth"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title fadeInUp"
}, "安全专业认证", -1));
const _hoisted_3 = {
  class: "auth-container fadeInUp"
};
const _hoisted_4 = {
  class: "auth-row"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = ["data"];
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = ["data"];
const _hoisted_9 = {
  class: "auth-row"
};
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = ["data"];
const _hoisted_12 = {
  class: "item"
};
const _hoisted_13 = ["data"];
const _hoisted_14 = {
  class: "item"
};
const _hoisted_15 = ["data"];
import { reactive } from 'vue';
export default {
  __name: 'mobile',
  setup(__props) {
    const img1 = require('@/assets/img/auth/cert1.svg');
    const img2 = require('@/assets/img/auth/cert2.svg');
    const img3 = require('@/assets/img/auth/cert3.svg');
    const img4 = require('@/assets/img/auth/cert4.svg');
    const img5 = require('@/assets/img/auth/cert5.svg');
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("object", {
        type: "image/svg+xml",
        data: _unref(img1)
      }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("object", {
        type: "image/svg+xml",
        data: _unref(img2)
      }, null, 8, _hoisted_8)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("object", {
        type: "image/svg+xml",
        data: _unref(img3)
      }, null, 8, _hoisted_11)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("object", {
        type: "image/svg+xml",
        data: _unref(img4)
      }, null, 8, _hoisted_13)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("object", {
        type: "image/svg+xml",
        data: _unref(img5)
      }, null, 8, _hoisted_15)])])])]);
    };
  }
};